import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { CreditPolicyActionTypes } from '../actions/credit-policy.actions';
import { SummaryCreditPolicyModel } from '../../models/summary-credit-policy.model';
import { CreditPolicyService } from '../../services/credit-policy.service';
import { LoadCreditPoliciesFailure, LoadCreditPolicies,LoadCreditPoliciesSuccess,LoadCreditPolicy,LoadCreditPolicyFailure,LoadCreditPolicySuccess,UpdateCreditPolicy,UpdateCreditPolicyFailure,UpdateCreditPolicySuccess,DeleteCreditPolicy,DeleteCreditPolicyFailure,DeleteCreditPolicySuccess,CreateCreditPolicy,CreateCreditPolicyFailure,CreateCreditPolicySuccess } from '../actions/credit-policy.actions';

@Injectable()
export class CreditPolicyEffects {
  constructor(
    private actions$: Actions,
    private service: CreditPolicyService
  ) { }

  /** 🔹 Get All */

  
  loadCreditpolicy$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(CreditPolicyActionTypes.LoadCreditPolicies),
    mergeMap((action: LoadCreditPolicies) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryCreditPolicyModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadCreditPoliciesFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadCreditPoliciesSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadCreditPoliciesFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadCreditPolicyById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(CreditPolicyActionTypes.LoadCreditPolicy),
        mergeMap((action: LoadCreditPolicy) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadCreditPolicySuccess(response)),
            catchError(error => of(new LoadCreditPolicyFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateCreditPolicy$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CreditPolicyActionTypes.UpdateCreditPolicy),
          mergeMap((action: UpdateCreditPolicy) =>
            this.service.update(action.payload.creditPolicy).pipe(
              switchMap(updated => [
                new UpdateCreditPolicySuccess({ creditPolicy: updated }),
              ]),
              catchError(error => of(new UpdateCreditPolicyFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteCreditPolicy$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CreditPolicyActionTypes.DeleteCreditPolicy),
          mergeMap((action: DeleteCreditPolicy) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteCreditPolicySuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteCreditPolicyFailure({ error })))
            )
          )
        ));



}
